export default "__VITE_ASSET__f2e526aa__"